export const SESSION_COOKIE_NAME = 'session'
export const SESSION_COOKIE_USER = 'sessionUser'
export const SESSION_EXPIRES_AT_COOKIE_NAME = 'sessionExpiresAt'
export const SESSION_CSRF_SECRET_COOKIE = `csrfSecret`
export const COOKIE_PATH = '/'

// Version to force logout - How to use: Increase or downgrade version
export const SESSION_VERSION = 'v1.0'
